import { gql, useQuery } from '@zenbusiness/application-commons-graphql';
import { camelCase } from 'lodash';

import {
  parseQuestionAnswerData,
  parseCalloutData,
  parseImageData,
  parseTitleData,
  parseSubtitleData,
  parseParagraphData,
  parseBulletListData,
  parseNumberedListData,
  parseDisclaimerData,
  parseMediumTextData,
  parseExtraLargeTextData
} from '#client/pages/EducationStudio/hooks/articleDataParsing';

export const GET_ARTICLE_CONTENT = gql`
  query GetArticleContent($articleKey: String!) {
    article(articleKey: $articleKey) {
      content: components {
        key: uuid
        component: type
        children: content {
          key: uuid
          type
          value
        }
      }
    }
  }
`;

const parseFunctionMap = {
  callout: parseCalloutData,
  title: parseTitleData,
  image: parseImageData,
  subtitle: parseSubtitleData,
  questionAnswer: parseQuestionAnswerData,
  bulletList: parseBulletListData,
  numberedList: parseNumberedListData,
  emphasizedParagraph: parseParagraphData,
  simpleParagraph: parseParagraphData,
  boldParagraph: parseParagraphData,
  disclaimer: parseDisclaimerData,
  mediumText: parseMediumTextData,
  extraLargeText: parseExtraLargeTextData
};

function parseContent(content) {
  return content.map((data) => {
    const parseFunction = parseFunctionMap[camelCase(data.component)];
    return parseFunction ? parseFunction(data) : data;
  });
}

export const useArticleCMS = (articleKey) => {
  const { loading, data } = useQuery(GET_ARTICLE_CONTENT, {
    variables: {
      articleKey
    },
    useCache: false
  });

  const content = loading ? [] : parseContent(data.article.content);

  return { loading, content };
};
